import { gql } from '@apollo/client'

const fullPublicVideoRequestDescriptionSuggestion = gql`
  fragment fullPublicVideoRequestDescriptionSuggestion on PublicVideoRequestDescriptionSuggestion {
    id
    title
    description
    requestOccasionId
    priority
    productIds
  }
`

export default fullPublicVideoRequestDescriptionSuggestion
